var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { ArrayTreeNodeTreeMode } from './tree-node-tree';
import { TreeSelect } from '@comall-backend-builder/components-basis';
import { services } from '@comall-backend-builder/core';
var StringArrayTreeSelect = services.TreeNodeArrayToTreeNodeIdArrayHOC(TreeSelect);

var ArrayTreeNodeIdsTreeMode = function (_super) {
  __extends(ArrayTreeNodeIdsTreeMode, _super);

  function ArrayTreeNodeIdsTreeMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 该种类型展示效果和tree-node-tree相同，但是需要从options获取对应的id,name
   * @param {Array} value
   * @param {Object} displayInfo
   * @returns {ReactElement}
   */


  ArrayTreeNodeIdsTreeMode.prototype.getDisplayComponent = function (value, displayInfo) {
    var options = displayInfo.options;

    if (!value || !options || options.length < 1) {
      return _super.prototype.getNotAvailableDisplayComponent.call(this, displayInfo);
    }

    return _super.prototype.getDisplayComponent.call(this, services.convertTreeNodeIdArrayToTreeNodeArray(value, options), displayInfo);
  };

  ArrayTreeNodeIdsTreeMode.prototype.getControlComponent = function (controlInfo) {
    var treeData = controlInfo.options;

    var treeSelectProps = __assign(__assign({}, controlInfo), {
      treeData: treeData,
      multiple: true
    });

    return React.createElement(StringArrayTreeSelect, __assign({}, treeSelectProps));
  };

  return ArrayTreeNodeIdsTreeMode;
}(ArrayTreeNodeTreeMode);

export { ArrayTreeNodeIdsTreeMode };